/**
 * Soft fleet geo helpers (shared, no React).
 */
const R_EARTH = 6371000;

export function haversineM(a, b) {
  if (!a || !b) return 0;
  const toR = (d) => (d * Math.PI) / 180;
  const dLat = toR(b[1] - a[1]);
  const dLng = toR(b[0] - a[0]);
  const la1 = toR(a[1]);
  const la2 = toR(b[1]);
  const h =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(la1) * Math.cos(la2) * Math.sin(dLng / 2) ** 2;
  return 2 * R_EARTH * Math.asin(Math.min(1, Math.sqrt(h)));
}

export function pathLengthM(coords) {
  let m = 0;
  for (let i = 1; i < (coords || []).length; i++) m += haversineM(coords[i - 1], coords[i]);
  return m;
}
